import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ServicesStrip } from '../components/ServicesStrip';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { QuoteSection } from '../components/QuoteSection';
import { Footer } from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navbar />
      <HeroSection />
      <ServicesStrip />
      <WhyChooseUs />
      <QuoteSection />
      <Footer />
    </div>
  );
}
